/* ============================================================
   Store Locator — behavior
   - Zip search: if a search results URL is configured, submitting
     redirects there with ?zip=VALUE appended. Otherwise the form
     just prevents default (no backend to search against yet).
   - Store logos: stagger in from below, once, the first time the
     section scrolls into view — GSAP if available, CSS fallback
     otherwise.
   ============================================================ */

function initAllStoreLocator(root) {
  var scope = root || document;
  scope.querySelectorAll('[data-store-locator]').forEach(function (section) {
    if (section.dataset.slInit === 'true') return;
    section.dataset.slInit = 'true';
    initStoreLocator(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initAllStoreLocator();
  });
} else {
  initAllStoreLocator();
}

document.addEventListener('shopify:section:load', function (event) {
  initAllStoreLocator(event.target);
});

function initStoreLocator(section) {
  var form = section.querySelector('[data-store-locator-form]');
  var zipInput = section.querySelector('[data-store-locator-zip]');
  var searchUrl = section.dataset.searchUrl;

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!searchUrl || !zipInput || !zipInput.value) return;
      var separator = searchUrl.indexOf('?') > -1 ? '&' : '?';
      window.location.href = searchUrl + separator + 'zip=' + encodeURIComponent(zipInput.value);
    });
  }

  var logosWrap = section.querySelector('[data-store-logos]');
  var logos = section.querySelectorAll('[data-store-logo]');
  var model = section.querySelector('[data-store-model]');
  var wantsLogoAnimation = section.dataset.logoAnimate === 'true';
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if ((!logosWrap || !logos.length) && !model) return;
  if (!wantsLogoAnimation && !model) return;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    logos.forEach(function (logo) {
      logo.style.opacity = 1;
      logo.style.transform = 'none';
    });
    if (model) {
      model.style.opacity = 1;
      model.style.transform = 'none';
    }
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        if (typeof window.gsap !== 'undefined') {
          if (model) {
            window.gsap.fromTo(
              model,
              { y: 60, opacity: 0 },
              { y: 0, opacity: 1, duration: 0.8, ease: 'power2.out' }
            );
          }
          if (wantsLogoAnimation && logos.length) {
            window.gsap.fromTo(
              logos,
              { y: 24, opacity: 0 },
              { y: 0, opacity: 1, duration: 0.5, ease: 'power2.out', stagger: 0.08 }
            );
          }
        } else {
          if (model) {
            model.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
            model.style.opacity = 1;
            model.style.transform = 'none';
          }
          if (wantsLogoAnimation) {
            logos.forEach(function (logo, i) {
              logo.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
              logo.style.transitionDelay = i * 0.08 + 's';
              logo.style.opacity = 1;
              logo.style.transform = 'none';
            });
          }
        }

        observer.unobserve(section);
      });
    },
    { threshold: 0.2 }
  );

  observer.observe(section);
}